import React, {Component} from "react"
import * as PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import adminTracking from "@irati-tracking/admin"
import authentication from "@irati/auth"

import {HeaderButtonStyle} from "../styled"

interface Props {}
interface State {
  buttonLabel: string
  buttonLink: string
}

class AdminButton extends Component<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    buttonLabel: "",
    buttonLink: ""
  }

  componentDidMount() {
    const {appPath, apps: contextApps} = this.context
    const {ADMIN, HOME} = contextApps
    const isAdminSection = appPath === ADMIN
    const buttonLabel = isAdminSection ? "platform.header.adminButton.exit" : "platform.header.adminButton.admin"
    const buttonLink = isAdminSection ? HOME : ADMIN
    this.setState({buttonLabel, buttonLink})
  }

  handleClick = () => {
    const {appPath, apps: contextApps} = this.context
    const {ADMIN} = contextApps
    const isAdminSection = appPath === ADMIN

    if (!isAdminSection) {
      adminTracking.adminHeaderClickAdminHub()
    }
  }

  render() {
    const {buttonLabel, buttonLink} = this.state
    const {appPath, apps: contextApps} = this.context
    const {ADMIN} = contextApps

    const isAdminSection = appPath === ADMIN
    const isLoggedIn = authentication.isLoggedIn()
    const hasAdminAccess = !!authentication.apps().admin

    if (!isLoggedIn || !hasAdminAccess) return null

    return (
      <HeaderButtonStyle
        to="/"
        app={buttonLink}
        primary={!isAdminSection}
        onClick={this.handleClick}
        id="platform_header_button_toggleAdmin">
        {buttonLabel && <FormattedMessage id={buttonLabel} />}
      </HeaderButtonStyle>
    )
  }
}

export default AdminButton
